<nz-card *ngIf="isLoading" [nzTitle]="withBorders ? loadingCardTitle : null" style="margin: 15px">
  <nz-spin></nz-spin>
  <ng-template #loadingCardTitle>
    <nz-skeleton-element *ngIf="widgetStructure === undefined" nzType="input" [nzActive]="true" [nzSize]="'small'"
      style="width: 200px">
    </nz-skeleton-element>
    <span *ngIf="widgetStructure != undefined">
      {{ widgetStructure.Title | locale }}
    </span>
  </ng-template>
</nz-card>
<ng-container *ngIf="!isEmpty && !isLoading" [ngTemplateOutlet]="widget">
</ng-container>

<ng-template #widget>
  <ng-template #cardTitle>
    <span class="widget-title">
      {{widgetStructure.Title | locale}}
    </span>
  </ng-template>
  <ng-template #extraTemplate>
    <button nz-button *ngIf="widgetStructure.ChartType == 9" (click)="exportToExcel();">{{'Export To Excel' | locale}}</button>
  </ng-template>

  <nz-card *ngIf="widgetStructure != undefined && widgetStructure.Show"
    [nzTitle]="(withBorders || widgetStructure.RenderAsSquare) ? cardTitle : null"
    [nzExtra]="withBorders && !widgetStructure.RenderAsSquare && widgetStructure.ChartType == 9 ? extraTemplate : null"
    [nzBordered]="withBorders" [nzHoverable]="withBorders" style="margin: 15px"
    (click)="widgetStructure.RenderAsSquare ? openWidgetDrawer() : 0" [ngClass]="{
      'zero-padding-card': !withBorders,
      'with-shadow': withBorders,
      'padding-less-nz-card':
        widgetStructure.ChartType === 9 && !widgetStructure.RenderAsSquare,
      'padding-sides-less-nz-card':
        widgetStructure.ChartType === 8 && !widgetStructure.RenderAsSquare
    }" [nzType]="'inner'">
    <ng-container *ngIf="widgetStructure.RenderAsSquare">
      <nz-statistic [nzPrefix]="prefixTplOne" [nzValueTemplate]="squareValue" [nzSuffix]="squareData.Suffix">
      </nz-statistic>
      <ng-template #prefixTplOne>
        <span style="padding-right: 15px">
          <i [class]="'fal ' + squareData.Label"></i>
        </span>
      </ng-template>
    </ng-container>
    <ng-container *ngIf="!widgetStructure.RenderAsSquare" [ngTemplateOutlet]="widgetBody">
    </ng-container>
  </nz-card>
  <nz-drawer [nzTitle]="widgetStructure.Title | locale" [nzWrapClassName]="'drawer-size-4x'" [nzVisible]="drawerVisible"
    (nzOnClose)="drawerVisible = false">
    <nz-skeleton *ngIf="loadingDrawer"> </nz-skeleton>
    <ng-container *ngIf="drawerVisible && !loadingDrawer" [ngTemplateOutlet]="widgetBody">
    </ng-container>
  </nz-drawer>
</ng-template>

<ng-template #squareValue>
  {{
  squareData.Type == "string"
  ? squareData.Value
  : squareData.Type == "number"
  ? (squareData.Value | number)
  : (squareData.Type == "amountCur"
  ? (squareData.Value | price : locatlCurrency)!
  : (squareData.Value | amount)!)!
  }}
</ng-template>
<ng-template #widgetBody>
  <div #widgetContainer class="widget">
    <ng-container *ngIf="widgetStructure.ChartType === 2">
      <ngx-charts-bar-horizontal *ngIf="!is2d" [results]="data" [animations]="true" [xAxis]="true" [yAxis]="true"
        [view]="[
          widgetContainer.offsetWidth - 25,
          widgetContainer.offsetWidth - 25
        ]" [legend]="widgetStructure.AdditionalInformationParsed.DisplayLegend" legendPosition="right"
        [scheme]="colorScheme">
      </ngx-charts-bar-horizontal>
      <ngx-charts-bar-horizontal-2d [view]="[
          widgetContainer.offsetWidth - 25,
          widgetContainer.offsetWidth - (width === 24 ? 750 : 25)
        ]" *ngIf="is2d" [results]="data" [animations]="true" [xAxis]="true" [yAxis]="true"
        [legend]="widgetStructure.AdditionalInformationParsed.DisplayLegend" legendPosition="right"
        [scheme]="colorScheme">
      </ngx-charts-bar-horizontal-2d>
    </ng-container>
    <ng-container *ngIf="widgetStructure.ChartType === 7">
      <ngx-charts-bar-vertical *ngIf="!is2d" [results]="data" [animations]="true" [xAxis]="true" [yAxis]="true"
        [view]="[widgetContainer.offsetWidth - 25, 300]"
        [legend]="widgetStructure.AdditionalInformationParsed.DisplayLegend" legendPosition="right"
        [scheme]="colorScheme">
      </ngx-charts-bar-vertical> 
       <ngx-charts-bar-vertical-2d [view]="[
          widgetContainer.offsetWidth - 25,
          widgetContainer.offsetWidth - 750
        ]" *ngIf="is2d" [results]="data" [animations]="true" [xAxis]="true" [yAxis]="true"
        [legend]="widgetStructure.AdditionalInformationParsed.DisplayLegend" legendPosition="right"
        [scheme]="colorScheme">
      </ngx-charts-bar-vertical-2d>
    </ng-container>
    <ng-container *ngIf="widgetStructure.ChartType === 8">
      <div class="numbers-widget">
        <nz-row [nzGutter]="[16, 16]">
          <ng-container *ngFor="let value of data">
            <nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="6" [nzXl]="4" [nzXXl]="24 / data.length">
              <nz-card nzType="inner" [nzTitle]="value.name">
                <nz-statistic [nzValueTemplate]="ChartEight"> </nz-statistic>
              </nz-card>
              <ng-template #ChartEight>
                {{
                value.Type == "number"
                ? (value.value | number)
                : (value.value | amount)!
                }}
              </ng-template>
            </nz-col>
          </ng-container>
        </nz-row>
      </div>
    </ng-container>
    <ng-container *ngIf="widgetStructure.ChartType === 1">
      <ngx-charts-line-chart *ngIf="widgetStructure.ChartType === 1" [scheme]="colorScheme"
        [legend]="widgetStructure.AdditionalInformationParsed.DisplayLegend" [legendPosition]="'right'"
        [view]="[widgetContainer.offsetWidth, 0]" [xAxis]="true" [yAxis]="true" [timeline]="true" [results]="data">
      </ngx-charts-line-chart>
    </ng-container>
    <ng-container *ngIf="widgetStructure.ChartType === 5 && is2d">
      <div nz-row [nzGutter]="16">
        <div nz-col nzSpan="20">
          <div nz-col #widgetContainer class="pie-widget" *ngFor="let data of datas" [nzXs]="view.nzXs"
            [nzSm]="view.nzSm" [nzMd]="view.nzMd" [nzLg]="view.nzLg" [nzXl]="view.nzXl" [nzXXl]="view.nzXXl">
            <div>
              <ngx-charts-advanced-pie-chart [results]="data.data" [label]="data.label"
                [view]="[widgetContainer.offsetWidth, 200]">
              </ngx-charts-advanced-pie-chart>
            </div>
          </div>
        </div>
        <div nz-col nzSpan="4">
          <div class="widget-options">
            <nz-space nzDirection="vertical">
              <nz-space-item>
                <strong>{{ "Display" | locale }}</strong>
              </nz-space-item>
              <nz-space-item>
                <div *ngFor="let key of valueColumnsKeys">
                  <label nz-checkbox [(ngModel)]="valueColumns[key]" (ngModelChange)="setData()">
                    {{ key | locale }}
                  </label>
                </div>
              </nz-space-item>
            </nz-space>
          </div>
        </div>
      </div>
      <nz-space>
        <nz-space-item>
          <nz-card [nzBordered]="false" style="width: 100%"> </nz-card>
        </nz-space-item>
        <nz-space-item> </nz-space-item>
      </nz-space>
    </ng-container>
    <ng-container *ngIf="widgetStructure.ChartType === 6 || widgetStructure.ChartType === 4">
      <ngx-charts-pie-chart [results]="data" [view]="[
          widgetContainer.offsetWidth - 25,
          widgetContainer.offsetWidth - 25
        ]" [legend]="widgetStructure.AdditionalInformationParsed.DisplayLegend"
         [scheme]="colorScheme"
        >
      </ngx-charts-pie-chart>
    </ng-container>
    <ng-container *ngIf="widgetStructure.ChartType === 9" [ngTemplateOutlet]="tableWidget">
    </ng-container>
    <ng-container *ngIf="widgetStructure.ChartType === 12">
      <div *ngIf="dataResponse != null" [innerHTML]="dataResponse.html | safeHtml"></div>
      <!-- <style>
        {{dataResponse.css}}
      </style> -->
    </ng-container>
    <ng-container *ngIf="widgetStructure.ChartType === 13">
      <app-cart-products-widget [products]="dataResponse"></app-cart-products-widget>
    </ng-container>
  </div>
</ng-template>
<ng-template #tableWidget>
  <app-table-section [tableCols]="this.widgetStructure.ColumnSettingsParsed" [dataset]="dataTable.dataset"
    [tableName]="dataTable.name" [cellSettings]="cellSettings" style="width: 100%">
  </app-table-section>
</ng-template>
